import React from 'react';
import daechlis from '@/public/svg/daechlis.svg';

interface PageHeroProps {
    eyebrow: string;
    title: React.ReactNode;
    text?: string;
    illustration?: string;
    children?: React.ReactNode;
}

const PageHero: React.FC<PageHeroProps> = ({ eyebrow, title, text, illustration, children }) => (
    <section className="w-full bg-primaryLight/40 text-textColor">
        <img src={daechlis} alt="" className="w-full h-auto object-contain" />
        <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-8 px-4 py-10 md:grid-cols-[1fr_auto] md:py-14">
            <div>
                <p className="mb-3 text-sm font-bold uppercase tracking-[0.2em]">{eyebrow}</p>
                <h1 className="text-4xl font-extrabold leading-tight sm:text-5xl">{title}</h1>
                {text && <p className="mt-4 max-w-xl text-lg sm:text-xl">{text}</p>}
                {children}
            </div>
            {illustration && (
                <img src={illustration} alt="" className="hidden h-48 w-auto max-w-sm object-contain md:block lg:h-56" />
            )}
        </div>
    </section>
);

export default PageHero;
